import React, { createContext, useContext, useState, useCallback } from 'react';
import { VendorTrackingDetails } from '../services/vendor/types';
import { useExtension } from '../extension';


interface DeeplinkModalContextType {
    requestRedirect: (trackingDetails: VendorTrackingDetails) => void;
}

const DeeplinkModalContext = createContext<DeeplinkModalContextType>({
    requestRedirect: (_trackingDetails: VendorTrackingDetails) => {}
});

const DeeplinkModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [subjectDetails, setSubjectDetails] = useState<VendorTrackingDetails | null>(null);
    const { openDeepLink } = useExtension();

    const requestRedirect = useCallback((trackingDetails: VendorTrackingDetails) => setSubjectDetails(trackingDetails), []);

    const handleCancel = () => setSubjectDetails(null);

    const handleConfirm = () => {
        if (subjectDetails) openDeepLink(subjectDetails);
        setSubjectDetails(null);
    };

    return (
        <DeeplinkModalContext.Provider value={{ requestRedirect }}>
            {children}
            {subjectDetails && (
                <div className="deeplink-modal-overlay" onClick={handleCancel}>
                    <div className="deeplink-modal" onClick={(e) => e.stopPropagation()}>
                        <h3>Leaving Rewards</h3>
                        <p>You'll be redirected to the store to continue. Cashback tracking starts once you land there.</p>
                        <div className="deeplink-modal-actions">
                            <button className="deeplink-modal-cancel" onClick={handleCancel}>Cancel</button>
                            <button className="deeplink-modal-confirm" onClick={handleConfirm}>Continue</button>
                        </div>
                    </div>
                </div>
            )}
        </DeeplinkModalContext.Provider>
    );
};

const useDeeplinkModal = () => useContext(DeeplinkModalContext);

export { DeeplinkModalProvider, useDeeplinkModal };